export enum AppFeatureKey {
    MyWorkplace = 'MyWorkplace',
    MyWorkplaceExternal = 'MyWorkplaceExternal',
    Header = 'Header'
}
